import React from 'react'
import PropTypes from 'prop-types'
import styles from './styles.module.scss'
import Icon from 'srcReact/components/icons/Icon'
import Link from 'react-router-dom/Link'
import { isNative } from 'srcReact/helpers/utils'

const LinkButton = ({
  href,
  size,
  text,
  role,
  style,
  customStyle,
  dropdownItemProps,
  icon,
  onClick,
  target,
  reactLink = false
}) => {
  const isNativeDevice = isNative()
  return (
    <React.Fragment>
      {reactLink && !isNativeDevice ? (
        <Link
          to={href}
          className={`${styles.linkButton} ${size ? styles[size] : ''} ${style ? styles[style] : ''} ${
            customStyle ? customStyle : ''
          }`}
          {...dropdownItemProps}
          role={role}
          onClick={onClick}
          target={target}>
          {icon && icon.positiow === 'start' && (
            <Icon name={icon.name} styleModifier={styles.iconStart} alt={icon.alt} />
          )}
          {text}
          {icon && icon.position === 'end' && <Icon name={icon.name} alt={icon.alt} />}
        </Link>
      ) : (
        <a
          href={href}
          className={`${styles.linkButton} ${size ? styles[size] : ''} ${style ? styles[style] : ''} ${
            customStyle ? customStyle : ''
          }`}
          {...dropdownItemProps}
          role={role}
          onClick={onClick}
          target={target}>
          {icon && icon.positiow === 'start' && (
            <Icon name={icon.name} styleModifier={styles.iconStart} alt={icon.alt} />
          )}
          {text}
          {icon && icon.position === 'end' && <Icon name={icon.name} alt={icon.alt} />}
        </a>
      )}
    </React.Fragment>
  )
}

LinkButton.propTypes = {
  href: PropTypes.string.isRequired,
  size: PropTypes.string,
  text: PropTypes.string.isRequired,
  role: PropTypes.string,
  style: PropTypes.string,
  customStyle: PropTypes.string,
  dropdownItemProps: PropTypes.object,
  icon: PropTypes.object,
  onClick: PropTypes.func,
  target: PropTypes.string
}

LinkButton.defaultProps = {
  size: 'medium',
  role: '',
  style: 'primary',
  customStyle: '',
  dropdownItemProps: {},
  icon: {}
}

export default LinkButton
